export enum Cart {
  ADD_PRODUCT = "ADD_PRODUCT",
  CHANGE_PRODUCT_PROPERTY = "CHANGE_PRODUCT_PROPERTY",
  REMOVE_PRODUCT = "REMOVE_PRODUCT",
  SET_PRODUCTS = "SET_PRODUCTS",
  SET_PAGE_ERROR = "SET_PAGE_ERROR",
  SET_META = "SET_META",
}

export enum Order {
  CLEAR = "ORDER_CLEAR",
  SET = "ORDER_SET",
}

export enum Sort {
  SET = "SORT_SET",
}

export enum SortDirections {
  ASC = "asc",
  DESC = "desc",
}

export enum ProductProperties {
  ID = "id",
  QUANTITY = "quantity",
  TOTAL_PRICE = "total_price",
}
